module.exports = __webpack_public_path__ + "img/logo-ivace-gva.2508f4ce.png";